<template>
  <div class="wrapper">
    <div class="title">
      <div class="t-left">
        <div class="v-line"></div>
        <div class="value">新闻资讯</div>
      </div>
      <div class="t-right" @click="$router.push('/news?classifyId=1')">
        <span>更多</span>
        <i class="el-icon-arrow-right"></i>
      </div>
    </div>
    <div class="h-line"></div>
    <div class="content">
      <div class="c-left">
        <div class="classify">
          <div class="c-item" :class="currentClassifyId == v.classifyId?'act':''" v-for="(v,i) in classifyList"
               :key="i" @click="selectClassify(v)">
            <span>{{ v.name }}</span>
            <div class="v-line" v-if="i !== classifyList.length - 1"></div>
          </div>
        </div>
        <div class="cl-content">
          <el-empty v-if="newsList.length < 1" description="暂无信息"></el-empty>
          <div class="clc-main" v-else>
            <div class="clcm-item one" @click="goNewsDetail(newsList[0])">
              <div class="o-title">{{ newsList[0].title }}</div>
              <div class="o-desc">{{ newsList[0].desc }}</div>
            </div>
            <div class="clcm-item two" v-if="newsList[1]" @click="goNewsDetail(newsList[1])">
              •<span>{{ newsList[1].title }}</span>
            </div>
            <div class="clcm-item three" v-if="newsList[2]" @click="goNewsDetail(newsList[2])">
              •<span>{{ newsList[2].title }}</span>
            </div>
            <div class="four-five-six" v-if="newsList.length > 3">
              <div class="clcm-item four" @click="goNewsDetail(newsList[3])">
                <el-image :src="newsList[3].image" lazy></el-image>
                <div class="title"><span>{{ newsList[3].title }}</span></div>
              </div>
              <div class="clcm-item five" v-if="newsList[4]" @click="goNewsDetail(newsList[4])">
                <el-image :src="newsList[4].image" lazy></el-image>
                <div class="title"><span>{{ newsList[4].title }}</span></div>
              </div>
              <div class="clcm-item six" v-if="newsList[5]" @click="goNewsDetail(newsList[5])">
                <el-image :src="newsList[5].image" lazy></el-image>
                <div class="title"><span>{{ newsList[5].title }}</span></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="v-line"></div>
      <div class="c-right">
        <div class="banner" v-if="newestActivityList[0]">
          <el-carousel height="236px">
            <el-carousel-item v-for="(v,i) in newestActivityList[0].banner" :key="i">
              <el-image :src="v"  @click="goNewsDetail(newestActivityList[0])"></el-image>
            </el-carousel-item>
          </el-carousel>
        </div>
        <div class="classify-name">最新活动</div>
        <div class="cr-main">
          <el-empty v-if="newestActivityList.length < 1" description="暂无信息"></el-empty>
          <div v-else class="crm-content">
            <div class="crmc-item one" @click="goNewsDetail(newestActivityList[0])">
              <el-image :src="newestActivityList[0].image" lazy></el-image>
              <div class="title">{{ newestActivityList[0].title }}</div>
            </div>
            <div class="crmc-item two" v-if="newestActivityList[1]" @click="goNewsDetail(newestActivityList[1])">
              •<span>{{ newestActivityList[1].title }}</span>
            </div>
            <div class="crmc-item three" v-if="newestActivityList[2]" @click="goNewsDetail(newestActivityList[2])">
              •<span>{{ newestActivityList[2].title }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {getCity} from "@/utils/locate";

export default {
  name: "News",
  data() {
    return {
      classifyList: [
        {
          classifyId: 1,
          name: '行业新闻'
        },
        {
          classifyId: 2,
          name: '城市新闻'
        },
        {
          classifyId: 3,
          name: '通知公告'
        }
      ],
      currentClassifyId: 1,
      newsList: [],
      newestActivityList: []
    }
  },
  created() {
    this.getNewsList()
    this.getNewestActivityList()
  },
  computed: {
    city() {
      return getCity()
    }
  },
  methods: {
    /**
     * 新闻资讯—最新活动
     */
    getNewestActivityList() {
      this.$request.get('/Home/newestActivityNews').then(res => {
        if (res.code === 0) {
          this.newestActivityList = res.data
        }
      })
    },
    /**
     * 去新闻资讯详情页
     * @param newsId
     */
    goNewsDetail({newsId}) {
      this.$router.push(`/news/detail?newsId=${newsId}`)
    },
    /**
     * 新闻资讯—分类选择
     */
    getNewsList() {
      this.$request.get('/Home/news', {
        params: {
          classifyId: this.currentClassifyId,
          areaId: this.city.areaId
        }
      }).then(res => {
        if (res.code === 0) {
          this.newsList = res.data
        }
      })
    },
    /**
     * 选择分类
     * @param classifyId
     */
    selectClassify({classifyId}) {
      this.currentClassifyId = classifyId
      this.getNewsList()
    }
  }
}
</script>

<style scoped lang="scss">
.wrapper {
  width: 100%;
  display: flex;
  flex-direction: column;

  .title {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding: 0 12px;

    .t-left {
      display: flex;
      flex-direction: row;
      align-items: center;

      .v-line {
        width: 4px;
        height: 16px;
        background-color: #1464FF;
        border-radius: 9px;
      }

      .value {
        color: #2D2D2D;
        font-weight: bold;
        font-size: 18px;
        margin-left: 5px;
      }
    }

    .t-right {
      display: flex;
      flex-direction: row;
      align-items: center;
      cursor: pointer;

      &:hover {
        text-decoration: underline;
        text-decoration-color: #1464FF;
      }

      span, i {
        color: #1464FF;
        font-size: 14px;
        font-weight: bold;
      }
    }
  }

  .h-line {
    width: 100%;
    height: 1px;
    background-color: #D7D7D7;
    margin-top: 8px;
  }

  .content {
    width: 100%;
    height: 430px;
    margin-top: 25px;
    display: flex;
    flex-direction: row;

    .c-left {
      display: flex;
      flex-direction: column;
      flex: 1;
      width: 0;

      .classify {
        display: flex;
        flex-direction: row;
        align-items: center;

        .c-item {
          display: flex;
          flex-direction: row;
          align-items: center;

          &.act span {
            color: #1464FF;
          }

          span {
            color: #6C6C6C;
            font-weight: bold;
            font-size: 20px;
            cursor: pointer;
          }

          .v-line {
            width: 1px;
            height: 16px;
            background-color: #D8D8D8;
            margin: 0 20px;
          }
        }
      }

      .cl-content {
        display: flex;
        flex-direction: column;
        width: 100%;

        .el-empty {
          margin-top: 50px;
        }

        .clcm-item {
          cursor: pointer;

          &:hover {
            color: #1464FF;
          }
        }

        .one {
          display: flex;
          flex-direction: column;
          color: #000000;
          width: 100%;
          margin-top: 32px;

          .o-title {
            font-size: 26px;
            font-weight: bold;
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
          }

          .o-desc {
            font-size: 16px;
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
            margin-top: 12px;
          }
        }

        .two, .three {
          color: #000000;
          font-size: 14px;

          span {
            margin-left: 5px;
          }
        }

        .two {
          margin-top: 44px;
        }

        .three {
          margin-top: 12px;
        }

        .four-five-six {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 32px;
          margin-top: 38px;
          width: 100%;

          .clcm-item {
            display: flex;
            flex-direction: column;
            align-items: center;
            width: 246px;

            &:hover .title {
              color: #1464FF;
            }

            .el-image {
              width: 246px;
              height: 140px;
              border-radius: 8px;
            }

            .title {
              width: 100%;
              color: #000000;
              font-size: 12px;
              font-weight: bold;
              margin-top: 5px;
              padding: 0 10px;
              display: flex;
              flex-direction: row;
              justify-content: center;

              span {
                text-overflow: ellipsis;
                overflow: hidden;
                white-space: nowrap;
              }
            }
          }
        }
      }
    }

    .v-line {
      background-color: #D7D7D7;
      width: 1px;
      height: 100%;
      margin: 0 40px;
    }

    .c-right {
      width: 316px;
      display: flex;
      flex-direction: column;

      .banner {
        width: 100%;
        height: 236px;
        border-radius: 8px;
        overflow: hidden;
        margin-bottom: 4px;
      }

      .classify-name {
        color: #000000;
        font-size: 16px;
        font-weight: bold;
        margin-bottom: 4px;
      }

      .cr-main {
        display: flex;
        flex-direction: column;
        flex: 1;
        height: 0;

        .crmc-item {
          cursor: pointer;

          &:hover, &:hover .title {
            color: #1464FF;
          }
        }

        .one {
          display: flex;
          flex-direction: row;
          align-items: flex-start;

          .el-image {
            width: 132px;
            height: 90px;
          }

          .title {
            flex: 1;
            width: 0;
            font-size: 16px;
            font-weight: bold;
            color: #000000;
            display: -webkit-box;
            -webkit-line-clamp: 4;
            -webkit-box-orient: vertical;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }

        .two, .three {
          color: #000000;
          font-size: 12px;
          font-weight: bold;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          overflow: hidden;
          text-overflow: ellipsis;
          margin-top: 3px;

          span {
            margin-left: 5px;
          }
        }

        .two {
          margin-top: 5px;
        }
      }
    }
  }
}
</style>